<template>
  <div>
    <div v-if="this.$store.state.webNavigator=='pc'" class="news-list-right">
      <div class="positionRE ">
        <div class="font30px positionAB news-article-tlt">
          <div class="article-tlt-hr displayIB"></div>
          <span class="article-tlt">最新文章</span>
          <div class="article-tlt-hr displayIB"></div>
        </div>
        <div class="news-article-list">
          <div class="newsArticle-list-bar positionRE pointEr" v-for="(item , index) in recommodList" :key="index"  @click="gotoPath(item)">
            <div class="displayIB">
              <imgPath :src="item.articleImg" :outstyle="{width: 79*(100/960)+'vw',height: 52*(100/960)+'vw'}" :domain="item.articleImg"/>
            </div>
            <div class="displayIB newsArticle-list-right">
              <p class="newsArticle-list-tlt font16px">{{item.articleTitle}}</p>
              <p class="newsArticle-list-time font14px col99999 positionAB"><span class="text-down" style="margin-left:0">
                  <imgPath :src="src" :domain="src"/>
                </span>{{item.submissionTime}}</p>
            </div>
          </div>
        </div>
      </div>
      <div>
        <div class="font30px hot-article-tlt">
          <div class="article-tlt-hr displayIB"></div>
          <span class="article-tlt">热门文章</span>
          <div class="article-tlt-hr displayIB"></div>
        </div>
        <div class="news-hot-list">
          <div v-for="(item , index) in hotList" :key="index"  @click="gotoPath(item)">
            <div class="news-hot-topBar positionRE" v-if="index==0">
              <imgPath :src="item.articleImg" :outstyle="{width: 175*(100/960)+'vw',height: 115*(100/960)+'vw'}" :domain="item.articleImg"/>
              <p class="font16px news-hot-topText positionAB colffffff overflowText">{{item.articleTitle}}</p>
            </div>
            <div class="article-hotList-p pointEr font16px"><span
              class="article-hotList-span">{{index + 1+'.'}}</span><span class="overflowText article-hotList-span2">{{item.articleTitle}}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
<!--      <div></div>-->
<!--      <div>-->
<!--        <div></div>-->
<!--        <div></div>-->
<!--      </div>-->
    </div>
  </div>

</template>

<script>
import { myFun}  from '../../plug/modifyImagePath';
import imgPath from '../imgPath/imgPath';
import config from '@/others/interface';
import {$get, $post, } from '@/others/ajax';

export default {
  name: 'articleSidebar',
  components: {
    imgPath
  },
  props: {},
  data () {
    return {
      reg: /<\/?.+?\/?>/g,
      hotList: [],
      recommodList: [],
      imgUrl: 'https://jusexcx.zmelo.com/',
      src: myFun("https://jusewebapp.oss-cn-hangzhou.aliyuncs.com/zml-gw/v1.1.1/icon/textTime.png"),
    };
  },
  watch: {
    $route (to, form) {
    },
  },
  methods: {
    async getRightList () {
      let res = await $get(config.zmlgw + '/web/getOne', {pageSize: 10, firstPage: 6, });
      if (res.code == 200) {
        this.recommodList = res.data.recommod;
        this.hotList = res.data.data;
      }
    },
    httptype (url) { // 图片判断
      if (url) {
        url.toString();
        if (url.indexOf('http') == '-1') {
          return this.imgUrl + url;
        } else {
          return url;
        }
      }
    },
    gotoPath (item) {
      let brandInfo = {
        articleKeyWord: item.articleKeyWord,
      };
      sessionStorage.setItem('brandInfo', JSON.stringify(brandInfo));
      sessionStorage.setItem('bannerType', '0');
      this.$router.push({path: '/brandNewsInfo/' + item.articleid + '/1/' + item.articleid + '.html', });
    },
  },
  asyncData ({store, route, app, }) {

  },
  mounted () {
    this.getRightList();
  },
  beforeDestroy () {
  },
  computed: {},
  created () {
  },
  filters: {},
};
</script>

<style lang="less" scoped>
  @media screen and (max-width: 800px) {
    @import url('../articleSidebar/articleSidebarPhone');
  }

  @media screen and (min-width: 800px) {
    @import url('../articleSidebar/articleSidebar');
  }

</style>



// WEBPACK FOOTER //
// articleSidebar.vue